/**
 * Custom logger utility that suppresses non-error logs in production
 * to avoid verbose logging in the browser console.
 */

const isProduction = process.env.NODE_ENV === 'production';

const logger = {
  log: (...args) => {
    if (!isProduction) {
      console.log(...args);
    }
  },
  
  warn: (...args) => {
    if (!isProduction) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (!isProduction) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (!isProduction) {
      console.debug(...args);
    }
  },
  
  // Always show errors, even in production
  error: (...args) => {
    console.error(...args);
  },
  
  // Group methods - only shown in development
  group: (label) => {
    if (!isProduction) {
      console.group(label);
    }
  },
  
  groupCollapsed: (label) => {
    if (!isProduction) {
      console.groupCollapsed(label);
    }
  },
  
  groupEnd: () => {
    if (!isProduction) {
      console.groupEnd();
    }
  }
};

export default logger; 